import PropTypes from "prop-types"
import React, { Component } from "react"

import BuilderUtils from "../../../lib/BuilderUtils"
import ConditionalField, { ConditionalFieldBlock } from "../../common/ConditionalField"
import WellStatusName from "../../common/WellStatusName"

class EditDetailsEngeneringAndDesign extends Component {
  onFieldUpdate = (elem) => {
    const { onFieldUpdate, data } = this.props
    let { value } = elem.target
    const { checked } = elem.target
    if (elem.target.type === "checkbox") {
      value = !!checked
    }
    if (elem.target.type === "radio") {
      value = value === "true"
    }
    onFieldUpdate(elem.target.name, value, data.id)
  }

  render() {
    const { data } = this.props
    return (
      <ConditionalFieldBlock scope="well" fields={BuilderUtils.fieldsPrStatus("engineering_and_design")}>
        <div id="engineering_and_design" className="Details-edit__section">
          <h3>
            <WellStatusName statusKey={"engineering_and_design"} />
          </h3>
          <div className="Details-edit__wrapper">
            <div className="Details-edit__part">
              <ConditionalField scope="well" field="afc">
                <div className={"Details-edit__radiowrapper radio-input radio-input--horizontal"}>
                  <label className="radio-input__mainlabel">
                    AfC
                    <span className="radio-input__sublabel">(Application For Concent)</span>
                  </label>
                  <div className="radio-input__optionwrapper">
                    <label className={`radio-input__option${data.well.afc ? " selected" : ""}`}>
                      <span className="radio-input__label">Yes</span>
                      <span className="check-indicator"></span>
                      <input onChange={this.onFieldUpdate} className="radio-input__radio" type="radio" name="well.afc" value={true} />
                    </label>
                    <label className={`radio-input__option${data.well.afc ? "" : " selected"}`}>
                      <span className="radio-input__label">No</span>
                      <span className="check-indicator"></span>
                      <input onChange={this.onFieldUpdate} className="radio-input__radio" type="radio" name="well.afc" value={false} />
                    </label>
                  </div>
                </div>
              </ConditionalField>
              <ConditionalField scope="well" field="afd">
                <div className={"Details-edit__radiowrapper radio-input radio-input--horizontal"}>
                  <label className="radio-input__mainlabel">
                    AfD
                    <span className="radio-input__sublabel">(Application For Discharge)</span>
                  </label>
                  <div className="radio-input__optionwrapper">
                    <label className={`radio-input__option${data.well.afd ? " selected" : ""}`}>
                      <span className="radio-input__label">Yes</span>
                      <span className="check-indicator"></span>
                      <input onChange={this.onFieldUpdate} className="radio-input__radio" type="radio" name="well.afd" value={true} />
                    </label>
                    <label className={`radio-input__option${data.well.afd ? "" : " selected"}`}>
                      <span className="radio-input__label">No</span>
                      <span className="check-indicator"></span>
                      <input onChange={this.onFieldUpdate} className="radio-input__radio" type="radio" name="well.afd" value={false} />
                    </label>
                  </div>
                </div>
              </ConditionalField>
            </div>
          </div>
        </div>
      </ConditionalFieldBlock>
    )
  }
}

EditDetailsEngeneringAndDesign.propTypes = {
  data: PropTypes.object,
  onFieldUpdate: PropTypes.func,
}

export default EditDetailsEngeneringAndDesign
